//import update from 'immutability-helper';

const emptyState = {
  data: {}
}

const IncentivesReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "INCENTIVES_INIT": {
      let newData = JSON.parse(JSON.stringify(action.payload));
      return {...state, data: newData};
    }
    default: {
      return state
    }
  }
}

export default IncentivesReducer